import gql from "graphql-tag";

export const pageGQL = gql`
  query Page($input: PageQueryInput) {
    page(input: $input) {
      total
      items {
        assets
        group
        id
        title
        position
        page
        metadata
        page
        cards {
          assets
          group
          data {
            ... on LinkFeaturedCardData {
              __typename
              redirectUrl
            }
            ... on PathFeaturedCardData {
              __typename
              internalPath
            }
            ... on TournamentFeaturedCardData {
              __typename
              tournaments {
                game {
                  category
                  description
                  developer
                  hasBattle
                  featured
                  hasSolo
                  hasTournament
                  id
                  metadata
                  orientation
                  publisher
                  status
                  title
                  type
                }
                id
                status
              }
            }
            ... on GameFeaturedCardData {
              __typename
              game {
                description
                category
                developer
                featured
                hasBattle
                hasSolo
                hasTournament
                id
                metadata
                orientation
                publisher
                status
                title
                type
              }
            }
          }
          linkType
          id
          imageUrl
          metadata
          position
          title
        }
      }
    }
  }
`;
